import React from 'react';
import { Controller } from 'react-hook-form';
import { RadioButton } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';

const EzControlledRadioButton = (props) => {
  const { control, name, value, customClassNames, rules, onChange } = props;

  return (
    <Controller
      name={name}
      value={value}
      rules={rules}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <RadioButton
            {...field}
            checked={field.value}
            inputId={field.value}
            onChange={(e) => {
              if (onChange) {
                onChange(e);
              }
              field.onChange(e.checked);
            }}
            className={classNames({
              'p-invalid': fieldState.invalid,
              customClassNames,
            })}
          />
        );
      }}
    />
  );
};

EzControlledRadioButton.defaultProps = {
  customClassNames: '',
};

export default EzControlledRadioButton;
